import * as types from './mutation_types';

//Logged in user info
export const requestUserInfo = ({ commit }) => commit(types.REQUEST_USER_INFO);
export const receiveUserInfoError = ({ commit, dispatch }) => {
   
};
export const receiveUserInfoSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_USER_INFO_SUCCESS, data);

//TODO: this will need to be run on login
export const fetchUserInfo = (
      { dispatch },
      { vm },
   ) => {
      dispatch('requestUserInfo');

      const request = new Promise((resolve, reject) => {
         $.post(
            vm.BARD_HOST + '/user/user_info',
            {
               'token'      : localStorage.getItem('token'),
            }, function(data) {
               if (!data.error) {
                  resolve(data);
               } else {
                  reject(data);
               }
            }
         );
      });
    
      return request
        .then(( data ) => dispatch('receiveUserInfoSuccess', data))
        .catch((data) => {
            if (vm.isAPILoginError(data)) {
               dispatch('handleAPILoginError', data);
            } else {
               dispatch('receiveUserInfoError')
            }
         });
}


//User Profile (TODO: combine the info for this and the above /user_info call into
//one call that runs when the user logs in and keep the same global object
export const requestUserProfile = ({ commit }) => commit(types.REQUEST_USER_PROFILE);
export const receiveUserProfileError = ({ commit, dispatch }) => {
   
};
export const receiveUserProfileSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_USER_PROFILE_SUCCESS, data);

export const fetchUserProfile = (
      { dispatch },
      { vm },
   ) => {
      dispatch('requestUserProfile');

      const request = new Promise((resolve, reject) => {
         $.post(
            vm.BARD_HOST + '/user/profile',
            {
               'token'      : localStorage.getItem('token'),
            }, function(data) {
               if (!data.error) {
                  resolve(data);
               } else {
                  reject(data);
               }
            }
         );
      });
    
      return request
        .then(( data ) => dispatch('receiveUserProfileSuccess', data))
        .catch(( data ) => {
            if (vm.isAPILoginError(data)) {
                  dispatch('handleAPILoginError', data);
            } else {
               dispatch('receiveUserProfileError')
            }
        });
}

//Templates
export const requestTemplates = ({ commit }) => commit(types.REQUEST_TEMPLATES);
export const receiveTemplatesError = ({ commit, dispatch }) => {
   
};
export const receiveTemplatesSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_TEMPLATES_SUCCESS, data);

export const fetchTemplates = (
      { dispatch },
      { vm, channelRecid },
   ) => {
   dispatch('requestTemplates');

   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/tmpl/list',
         {
            'token'      : localStorage.getItem('token'),
            'chanRecid'  : channelRecid
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });
 
   return request
     .then(( data ) => dispatch('receiveTemplatesSuccess', data))
     .catch((data) => {
         if (vm.isAPILoginError(data)) {
            dispatch('handleAPILoginError', data);
         } else {
            dispatch('receiveTemplatesError', data);
         }
      });
};

//All Channels
export const requestChannels = ({ commit }) => commit(types.REQUEST_CHANNELS);
export const receiveChannelsError = ({ commit, dispatch }) => {
   
};
export const receiveChannelsSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_CHANNELS_SUCCESS, data);

export const fetchChannels = (
      { dispatch },
      { vm },
   ) => {
   dispatch('requestChannels');

   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/channel/list',
         {
            'token'      : localStorage.getItem('token'),
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });
 
   return request
     .then(( data ) => dispatch('receiveChannelsSuccess', data))
     .catch((data) => {
         if (vm.isAPILoginError(data)) {
            dispatch('handleAPILoginError', data);
         } else {
            dispatch('receiveChannelsError', data);
         }
        
     });
};

//All Categories
export const requestCategories = ({ commit }) => commit(types.REQUEST_CATEGORIES);
export const receiveCategoriesError = ({ commit, dispatch }) => {
   
};
export const receiveCategoriesSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_CATEGORIES_SUCCESS, data);

export const fetchCategories = (
      { dispatch },
      { vm },
   ) => {
   dispatch('requestCategories');

   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/category/list',
         {
            'token'      : localStorage.getItem('token'),
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });
 
   return request
     .then(( data ) => dispatch('receiveCategoriesSuccess', data))
     .catch((data) => {
         if (vm.isAPILoginError(data)) {
            dispatch('handleAPILoginError', data);
         } else {
            dispatch('receiveCategoriesError', data);
         }
     });
};

//Media Picker
export const toggleMediaPicker = (
   { state, commit }
) => {
   if (state.mediaPickerOpen) {
      commit(types.RESET_UPLOAD);
      commit(types.CLOSE_MEDIA_PICKER);
   } else {
      commit(types.OPEN_MEDIA_PICKER);
   }
}

export const openMediaPicker = (
   { commit }
) => {
   commit(types.OPEN_MEDIA_PICKER);
}

export const initData = (
   { commit },
   { channels, channelRecid, assetType, activeId, currActiveAssetRecid, multiSelect, isScoreboard } 
) => {
   commit(types.INIT_DATA, {channels, channelRecid, assetType, activeId, currActiveAssetRecid, multiSelect, isScoreboard});
}

export const closeMediaPicker = (
   { commit },
) => {
   commit(types.RESET_ACTIVE_MEDIA);
   commit(types.RESET_RECENT_MEDIA);
   commit(types.RESET_UPLOAD);
   commit(types.CLOSE_MEDIA_PICKER);
}

export const draggingAsset = (
   { commit },
   { assetRecid}
) => {
   commit(types.DRAGGING_ASSET, assetRecid);
}

export const stopDraggingAsset = (
   { commit }
) => {
   commit(types.STOP_DRAGGING_ASSET);
}

export const addSelectedAsset = (
   { commit },
   { assetRecid }
) => {
   commit(types.ADD_SELECTED_ASSET, assetRecid);
}

export const assignAsset = (
   { commit },
   { asset }
) => {
   commit(types.ASSIGN_ASSET, asset);
}

export const resetMP = (
   { commit }
) => {
   commit(types.RESET_MEDIA_PICKER);
}



//Recent Media
export const requestRecentMedia = ({ commit }) => commit(types.REQUEST_RECENT_MEDIA);
export const receiveRecentMediaError = ({ commit, dispatch }, {assetType, category}) => {
   
};
export const receiveRecentMediaSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_RECENT_MEDIA_SUCCESS, data);

export const fetchRecentMedia = (
   { dispatch, state },
   { vm, refresh = false },
 ) => {
   dispatch('requestRecentMedia');
   if (refresh) {
      dispatch('resetRecentMedia');
   }

   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/media/recent',
         {
            'token'         : localStorage.getItem('token'),
            'limit'         : 20,
            'page'          : state.mpRecentPage,
            'assetType'     : state.currSelectedAssetType,
            'categoryRecid' : state.currSelectedCategory,
            'channels'      : state.mpChannels.toString(),
            'searchTerm'    : state.currSearchTerm,
            'isScoreboard'  : state.isScoreboard
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });
 
   return request
     .then(( data ) => dispatch('receiveRecentMediaSuccess', data))
     .catch((data) => {
         if (vm.isAPILoginError(data)) {
            dispatch('global/handleAPILoginError', data, {root:true});
         } else {
            dispatch('receiveRecentMediaError', data);
         }
     });
};

export const resetRecentMedia = ({ commit }) => commit(types.RESET_RECENT_MEDIA);


//Active Media
export const requestActiveMedia = ({ commit }) => commit(types.REQUEST_ACTIVE_MEDIA);
export const receiveActiveMediaError = ({ commit, dispatch }, {assetType, category}) => {
   
};
export const receiveActiveMediaSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_ACTIVE_MEDIA_SUCCESS, data);

export const fetchActiveMedia = (
   { dispatch, state, rootState },
   { vm, refresh },
 ) => {
   dispatch('requestActiveMedia');
   if (refresh) {
      dispatch('resetActiveMedia');
   }
   
   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/media/active',
         {
            'token'         : localStorage.getItem('token'),
            'limit'         : 20,
            'page'          : state.mpActivePage,
            'assetType'     : state.currSelectedAssetType,
            'categoryRecid' : state.currActiveCategory,
            'channelRecid'  : state.mpChannelRecid
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });
 
   return request
     .then(( data ) => dispatch('receiveActiveMediaSuccess', data))
     .catch(() => {
         if (vm.isAPILoginError(data)) {
            dispatch('global/handleAPILoginError', data, {root:true});
         } else {
            dispatch('receiveActiveMediaError', data);
         }
     });
};

export const resetActiveMedia = ({ commit }) => commit(types.RESET_ACTIVE_MEDIA);


//Change type
export const changeCurrAssetType = (
   { commit },
   { type },
) => {
   commit(types.CHANGE_CURR_ASSET_TYPE, type);
}

export const changeCurrCategory = (
   { commit },
   { category },
) => {
   commit(types.CHANGE_CURR_CATEGORY, category);
}

export const changeCurrSearch = (
   { commit },
   { searchTerm },
) => {
   commit(types.CHANGE_CURR_SEARCH, searchTerm);
}

export const displayModal = (
   { commit, dispatch },
   { modalData },
) => {
   dispatch('closeModal');
   commit(types.DISPLAY_MODAL, modalData);
}

export const displayDeleteConfirmModal = (
   { dispatch },
   { assetTitle }
) => {
   let modalData = {};
   modalData.modalError = false;
   modalData.modalSubheadText = 'Delete';
   modalData.modalMessage = 'Are you sure you want to delete ' + assetTitle + '?';
   modalData.deleteConfirm = true;
   dispatch('displayModal', {modalData});
}

export const closeModal = (
   { dispatch, commit }
) => {
   commit(types.CLOSE_MODAL);
   dispatch('closeModal', {}, {root:true});
}

export const handleAPILoginError = (
   { dispatch },
   data
) => {
   if (data.message) {
      let subheadText = '';
      if (data.message.includes('Invalid or missing token')) {
         subheadText = 'Your token has expired or is invalid.';
      } else if (data.message.includes('Session has expired')) {
         subheadText = 'Your session has expired';
      }

      dispatch(
         'setErrorMessage',
         {
            subheadText,
            messageText: 'Please login again.',
            buttonText: 'Login',
            action: () => window.location.href = "login.html"
         },
         { root: true }
      )
   }
}


/* Unsaved Changes Modal */
export const handleUnsavedChangesModalSave = (
   { dispatch, commit }, 
   { vm }
) => {
   commit(types.CLOSE_MODAL);
   dispatch('handleUnsavedChangesModalSave', {vm}, {root:true});
}

export const handleUnsavedChangesModalLeave = (
   { dispatch, commit },
   { vm }
) => {
   commit(types.CLOSE_MODAL);
   dispatch('handleUnsavedChangesModalLeave', {vm}, {root:true});
}

export const handleUnsavedChangesModalCancel = (
   { dispatch, commit }
) => {
   commit(types.CLOSE_MODAL);
   dispatch('handleUnsavedChangesModalCancel', {}, {root:true});
}




/* UPLOAD */
export const requestUploadMedia = ({ commit }, {validFiles, invalidFiles}) => commit(types.REQUEST_UPLOAD_MEDIA, {validFiles, invalidFiles});
export const receiveUploadMediaError = ({ commit, dispatch }, error) => {
   
};
export const receiveUploadMediaSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_UPLOAD_MEDIA_SUCCESS, data);

export const noValidFiles = ({ commit }, data) => commit(types.NO_VALID_FILES);

export const uploadMedia = (
   { dispatch, state, commit },
   { vm, validFiles, invalidFiles },
 ) => {
   dispatch('requestUploadMedia', {validFiles, invalidFiles});

   if (validFiles.length == 0) {
      dispatch('noValidFiles');
      return;
   }

   let formData = new FormData();
   for (let file of validFiles) {
      formData.append('file[]', file);
   }

   var xhr = new XMLHttpRequest();
   let host = vm.API_HOST + '/upload.php';
   xhr.open('POST', host, true);

   xhr.addEventListener('readystatechange', function(e) {
      if( this.readyState === 4 ) {
         dispatch('receiveUploadMediaSuccess', validFiles);
         dispatch('ingestUploadedFiles', vm);
      }
   });

   if (xhr.upload) {
      // For handling the progress of the upload
      xhr.upload.addEventListener('progress', function(e) {
         if (e.lengthComputable) {
               state.uploadProgress = e.loaded;
               state.uploadTotal = e.total;
         }
      } , false);
   }

   xhr.send(formData);
};


//ingest the files we've just uploaded
export const requestIngestMedia = ({ commit }) => commit(types.REQUEST_INGEST_MEDIA);
export const receiveIngestMediaError = ({ commit, dispatch }, error) => {
   
};
export const receiveIngestMediaSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_INGEST_MEDIA_SUCCESS, data);

export const ingestUploadedFiles = (
   { dispatch, state, commit }, vm
) => {
   dispatch('requestIngestMedia');

   //promise to ingest one file into Bard
   var ingestPromise = function ingest(file) {
      return new Promise((resolve, reject) => {
         $.post(
            vm.BARD_HOST + '/' + vm.getStringFromFileType(file.type) + '/ingest',
            {
               token: localStorage.getItem('token'),
               uri: file.name,
               channelRecid: state.mpChannelRecid
            }, function(data) {
               //return the recid
               if (data.error) {
                  reject(-1);
               } else {
                  resolve(data.recid);
               }
            }
         ).fail(function(response) {
            console.log('Error: ' + response.responseText);
         });
      });
   }

   //run the ingest promises
   let ingestPromises = state.uploadedFiles.map(ingestPromise);
   let results = Promise.all(ingestPromises);
   results.then((data) => {
      if (!data.includes(-1)) {
         dispatch('receiveIngestMediaSuccess', data);
         dispatch('fetchUploadedFiles', {vm: vm, fileRecids: data});
      }
   });
};

//get the uploaded files from our DB
export const requestUploadedFiles = ({ commit }) => commit(types.REQUEST_UPLOADED_FILES);
export const receiveUploadedFilesError = ({ commit, dispatch }, error) => {
   
};
export const receiveUploadedFilesSuccess = ({ commit }, data) =>
  commit(types.RECEIVE_UPLOADED_FILES_SUCCESS, data);

export const fetchUploadedFiles = (
   { dispatch, commit, state },
   { vm, fileRecids }
) => {
   var fetchPromise = function getFiles(recid) {
      return new Promise((resolve, reject) => {
         $.post(
            vm.BARD_HOST + '/media/meta/' + recid,
            {
               token: localStorage.getItem('token')
            }, function(data) {
               if (data.error) {
                  reject(data.message);
               } else {
                  resolve(data);
               }
            }
         ).fail(function(response) {
            console.log('Error: ' + response.responseText);
            reject();
         });
      });
   }

   //run the fetchPromise promises
   let fetchPromises = fileRecids.map(fetchPromise);
   let results = Promise.all(fetchPromises);
   results.then((data) => {
      dispatch('receiveUploadedFilesSuccess', data);

      //This isn't the cleanest way to handle this but for now,
      //if the media picker is open then we're uploading in the media picker
      //so refresh those assets
      //if not, then we're uploading in the media library so call it's handle function
      if (state.mediaPickerOpen) {
         dispatch('fetchRecentMedia', {vm, refresh: true});
      } else {
         dispatch('handleUploadFinished', {vm}, {root:true});
      }
   });
};

export const resetUpload = (
   { dispatch, commit }
) => {
   commit(types.RESET_UPLOAD);
}



/* Smart Canvas Overlay */
export const openSmartCanvas = (
   { commit },
   { instanceRecid }
) => {
   commit(types.OPEN_SMART_CANVAS, instanceRecid);
}

export const closeSmartCanvas = (
   { commit, dispatch }
) => {
   dispatch('closeMediaPicker');
   commit(types.CLOSE_SMART_CANVAS);
   dispatch('handleSmartCanvasClose', {}, {root:true});
}

export const openInstance = (
   { rootState, commit }
) => {
   commit(types.OPEN_INSTANCE, rootState.currActiveChannelRecid);
}

export const logout = (
   { dispatch, commit },
   { vm }
) => {
   const request = new Promise((resolve, reject) => {
      $.post(
         vm.BARD_HOST + '/user/logout',
         {
            'token'        : localStorage.getItem('token')
         }, function(data) {
            if (!data.error) {
               resolve(data);
            } else {
               reject(data);
            }
         }
      );
   });

   return request
      .then(( data ) => {
         commit(types.USER_LOGOUT);
      })
      .catch(( data ) => {
         if (vm.isAPILoginError(data)) {
            dispatch('handleAPILoginError', data);
         } 
      }); 
}



export default () => {};



